import axios, { AxiosInstance } from 'axios';
// Получаем базовый URL из переменных окружения
const API_URL = process.env.REACT_APP_API_URL || 'https://admin.vkksu.com';
// Создаем единый экземпляр axios с базовыми настройками
export const apiInstance: AxiosInstance = axios.create({
  baseURL: API_URL,
  // timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});


// Экспортируем базовый URL для использования в других частях приложения
export const getApiUrl = () => API_URL;